const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://zsjxqdfwrg.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_API_URL: 'https://mcg4gxt6y1.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'taxonomy-company-1.13.4',
    HOSTNAME: 'https://company.valeglobal.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.valeglobal.forwoodsafety.com',
    WEBSOCKET: 'wss://opv2fciaaf.execute-api.us-west-2.amazonaws.com/prod'
  },
};

export default config;